import { z } from "zod";

import { labelSourceSchema } from "./enums";
import { printVariableExpressionSchema } from "./print-variable";

export const addLabelConfigurationSchema = z.object({
	id: z.string(),
	printVariableExpressions: z.array(printVariableExpressionSchema).optional(),
	templateName: z.string().optional(),
	zpl: z.string().optional(),
	zplExpression: z.string().optional(),
	onePerBatch: z.boolean().optional(),
	verificationCodeExpression: z.string().optional(),
	priorityExpression: z.string().optional(),
	labelSource: labelSourceSchema,
});
export type AddLabelConfiguration = z.infer<typeof addLabelConfigurationSchema>;
